import PropTypes from 'prop-types';
import { BsSliders, BsStars } from 'react-icons/bs';

const MODES = [
	{ id: 'form', label: 'Suchmaske', icon: BsSliders },
	{ id: 'agent', label: 'KI-Assistent', icon: BsStars },
];

/**
 * The two equal entry points of a new search; the choice is stored per user.
 */
const EntryModeSwitch = ({ mode, onChange }) => (
	<div role="radiogroup" aria-label="Suchmodus" className="inline-flex gap-0.5 rounded-control bg-bgBase-400 p-0.5">
		{MODES.map(({ id, label, icon: Icon }) => {
			const active = id === mode;
			return (
				<button
					key={id}
					type="button"
					role="radio"
					aria-checked={active}
					onClick={() => onChange(id)}
					className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-control px-3 py-1.5 text-xs font-medium transition-colors ${
						active ? 'bg-white text-primary-700 shadow-sm' : 'text-bgBase-800 hover:text-text'
					}`}
				>
					<Icon className="h-3.5 w-3.5" />
					{label}
				</button>
			);
		})}
	</div>
);

EntryModeSwitch.propTypes = {
	mode: PropTypes.oneOf(['form', 'agent']).isRequired,
	onChange: PropTypes.func.isRequired,
};

export default EntryModeSwitch;
